import { Blog } from '@/commonTypes';
import React from 'react';
import styles from './styles.module.css';
import BlogFooter from '@/components/pages/home/HomeContent/SampleBlogs/BlogCard/BlogFooter';

export default function BlogInfo({ data }: { data?: Blog }) {
  return (
    <div className={`${styles.container}`}>
      <BlogFooter
        item={data}
        index={0}
        className={`${styles.footerClass}`}
        userNameClass={`${styles.userNameClass}`}
        metaClass={`${styles.metaClass}`}
        style={{ width: '42px', height: '42px', fontSize: '13px' }}
        showRole={true}
        infoSectionStyle={`${styles.infoSectionStyle}`}
      />
    </div>
  );
}
